export class SecurityScan {
    'snapshotId';
    'conclusion';
    'createdTime';
    'confidenceScore';
    'justification';
    'detectorType';
    'totalEvidenceCount';
    'results';
    'reviewerType';
    'reviewerIsRansomware';
    'reviewerConfidenceScore';
    'reviewerReason';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "SecurityScanConclusionEnum",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "confidenceScore",
            "baseName": "confidenceScore",
            "type": "number",
            "format": "float"
        },
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "SecurityScanDetectorTypeEnum",
            "format": ""
        },
        {
            "name": "totalEvidenceCount",
            "baseName": "totalEvidenceCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<SecurityScanResult>",
            "format": ""
        },
        {
            "name": "reviewerType",
            "baseName": "reviewerType",
            "type": "SecurityScanReviewerTypeEnum",
            "format": ""
        },
        {
            "name": "reviewerIsRansomware",
            "baseName": "reviewerIsRansomware",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reviewerConfidenceScore",
            "baseName": "reviewerConfidenceScore",
            "type": "number",
            "format": ""
        },
        {
            "name": "reviewerReason",
            "baseName": "reviewerReason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityScan.attributeTypeMap;
    }
    constructor() {
    }
}
export var SecurityScanConclusionEnum;
(function (SecurityScanConclusionEnum) {
    SecurityScanConclusionEnum["Clean"] = "CLEAN";
    SecurityScanConclusionEnum["HighChanceForRansomware"] = "HIGH_CHANCE_FOR_RANSOMWARE";
    SecurityScanConclusionEnum["DataAnomalyDetected"] = "DATA_ANOMALY_DETECTED";
    SecurityScanConclusionEnum["MalwareDetected"] = "MALWARE_DETECTED";
})(SecurityScanConclusionEnum || (SecurityScanConclusionEnum = {}));
export var SecurityScanDetectorTypeEnum;
(function (SecurityScanDetectorTypeEnum) {
    SecurityScanDetectorTypeEnum["Malware"] = "MALWARE";
    SecurityScanDetectorTypeEnum["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    SecurityScanDetectorTypeEnum["DataAnomaly"] = "DATA_ANOMALY";
})(SecurityScanDetectorTypeEnum || (SecurityScanDetectorTypeEnum = {}));
export var SecurityScanReviewerTypeEnum;
(function (SecurityScanReviewerTypeEnum) {
    SecurityScanReviewerTypeEnum["NoReview"] = "NO_REVIEW";
    SecurityScanReviewerTypeEnum["Llm"] = "LLM";
})(SecurityScanReviewerTypeEnum || (SecurityScanReviewerTypeEnum = {}));
